import React, { useEffect, useState } from 'react'
import Alert, { confirmedAlert } from "../component/Alert";
import apiService from "apiService";
import Select2 from "react-select";
import moment from "moment";

const ImmunizationHistory = (props) => {
  const [result, setResult] = useState([]);
  const [immunization, setImmunization] = useState([]);
  const [param, setParam] = useState({
    visit_id: props.detilPx.id,
    number: '',
    immunization_id: null,
    date: moment().format("YYYY-MM-DD"),
    type: null,
    description: ''
  });

  const getHistory = async () => {
    let res = await apiService.get(
      `/registration/immunization_histories/read/${props.detilPx.id}`
    );

    if (res && res.code === 200) {
      setResult(res.data);
    }
  };

  const delHistory = async (e) => {
    let res = await apiService.delete(
      `/registration/immunization_histories/delete/${e}`
    );

    if (res && res.code === 200) {
      setResult(res.data);
    }
  };

  const postHistory = async () => {
    let res = await apiService.put(
      `/registration/immunization_histories/update`, param
    );

    if (res) {
      if (res.code === 200) {
        setResult(res.data);
        setParam({
          ...param,
          number: '',
          immunization: null,
          immunization_id: null,
          date: moment().format("YYYY-MM-DD"),
          type: null,
          types: null,
          description: ''
        });

        Alert("success", "Data berhasil disimpan");
      } else {
        Alert("error", "Periksa kembali isian anda");
      }
    }
  };

  const getImmunization = async () => {
    let res = await apiService.get(`/management/immunizations/read`);

    if (res && res.code === 200) {
      setImmunization(res.data);
    }
  };

  useEffect(() => {
    getHistory();
    getImmunization();
  }, []);

  return (
    <div>
      <div className='card'>
        <div className='card-header'>
          <div className='row align-items-center'>
            <div className='col-lg-9'>
              <h4 className='h3 mb-0'>Riwayat Imunisasi</h4>
            </div>
            <div className='col-lg-3'>
              <button
                data-toggle='collapse'
                data-target='#collapsePreview'
                aria-expanded='false'
                aria-controls='collapsePreview'
                className='btn btn-outline-primary btn-block'>
                Tambah Data
              </button>
            </div>
          </div>
        </div>
        <div className='collapse' id='collapsePreview'>
          <div className='card-body bg-secondary'>
            <div className='row'>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label className='form-control-label'>
                    Nomor
                  </label>
                  <div className='input-group'>
                    <input
                      type='text'
                      value={param.number}
                      onChange={(e) => {
                        setParam({
                          ...param,
                          number: e.target.value,
                        });
                      }}
                      className='form-control'
                    />
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label className='form-control-label'>
                    Imunisasi
                  </label>
                  <div className='input-group'>
                    <Select2
                      className='form-control p-0 pt-1'
                      styles={{
                        control: (styles) => ({
                          ...styles,
                          backgroundColor: "white",
                          border: "none",
                        }),
                      }}
                      value={param.immunization}
                      onChange={(e) =>
                        setParam({
                          ...param,
                          immunization_id: e.value,
                          immunization: e,
                        })
                      }
                      options={immunization.map((data) => ({
                        value: data.id,
                        label: data.name,
                      }))}
                    />
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label className='form-control-label'>
                    Tanggal
                  </label>
                  <div className='input-group'>
                    <input
                      type='date'
                      value={param.date}
                      onChange={(e) => {
                        setParam({
                          ...param,
                          date: e.target.value,
                        });
                      }}
                      className='form-control'
                    />
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label className='form-control-label'>
                    Tipe
                  </label>
                  <div className='input-group'>
                    <Select2
                      className='form-control p-0 pt-1'
                      styles={{
                        control: (styles) => ({
                          ...styles,
                          backgroundColor: "white",
                          border: "none",
                        }),
                      }}
                      value={param.types}
                      onChange={(e) =>
                        setParam({
                          ...param,
                          type: e.value,
                          types: e,
                        })
                      }
                      options={[
                        {
                          value: "anak",
                          label: "Anak",
                        },
                        {
                          value: "corona",
                          label: "Corona",
                        },
                        {
                          value: "lain-lain",
                          label: "Lain-lain",
                        }
                      ]}
                    />
                  </div>
                </div>
              </div>
              <div className='col-12'>
                <div className='form-group'>
                  <label className='form-control-label'>
                    Deskripsi
                  </label>
                  <div className='input-group'>
                    <textarea
                      className='form-control'
                      onChange={(e) =>
                        setParam({ ...param, description: e.target.value })
                      }
                      value={param.description}
                      rows='3'
                    />
                  </div>
                </div>
              </div>
              <div className='col-12 text-right'>
                <button className='btn btn-primary mb-2' onClick={() => postHistory()}>
                  Simpan Data
                </button>
                <button
                  className='btn btn-outline-dark mb-2'
                  data-toggle='collapse'
                  data-target='#collapsePreview'
                  aria-expanded='false'
                  aria-controls='collapsePreview'>
                  Tutup
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='card-footer shadow'>
          <div className='row'>
            <div className='col-12'>
              <ul className='list-group shadow'>
                {result.map((item, keys) => {
                  return (
                    <li
                      className='checklist-entry list-group-item align-items-start'
                      key={keys}>
                      <div className='d-flex w-100 justify-content-between'>
                        <div>
                          <div className='d-flex w-100 align-items-center'>
                            <div className='badge badge-primary'>Imunisasi {item.type.toUpperCase()}</div>
                          </div>
                        </div>
                        <button onClick={(e) => {
                          confirmedAlert(
                            "Konfirmasi",
                            `Apakah anda akan menghapus data riwayat imunisasi ${item.immunization.name}?`,
                            function (confirmed) {
                              if (confirmed) {
                                delHistory(item.id);
                              }
                            }
                          );
                        }}
                          className='btn btn-outline-danger btn-sm'>
                          Hapus</button>
                      </div>
                      <div className='row'>
                        <div className='col-md-9'>
                          <div className='h3 mb-0'>{'[' + item.immunization.type + '] ' + item.immunization.name}</div>
                          <div className='h5'>No: {item.number}</div>
                          <div className='text-sm mt-1 mb-1'>{item.description}</div>
                          <mark className='text-xs'>Tanggal {moment(item.date).format("DD-MM-YYYY")}</mark>
                        </div>
                        <small className='col-md-3 pt-2 text-right text-sm'>
                          <div>Oleh: <span className='h5 mb-0'>{item.users.name}</span>
                          </div>
                          <div>{moment(item.created_at).format("DD-MM-YYYY HH:mm")}</div>
                        </small>
                      </div>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default ImmunizationHistory;